__turbopack_context__.v({
  "header": "a_f4aq_header",
  "loaderWrapper": "a_f4aq_loaderWrapper",
  "sortingInputWrapper": "a_f4aq_sortingInputWrapper",
  "sortingLabel": "a_f4aq_sortingLabel",
  "title": "a_f4aq_title",
  "wrapper": "a_f4aq_wrapper",
});
